import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Platform } from 'react-native';

export type BreadcrumbItem = {
  label: string;
  to?: string; // 可選連結；最後一項通常不帶連結
  key?: string;
};

export type BreadcrumbsProps = {
  items: BreadcrumbItem[];
  separator?: string;
  dense?: boolean;
  onNavigate?: (to: string) => void;
};

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, separator = '>', dense = false, onNavigate }) => {
  if (!items || items.length === 0) return null;
  return (
    <View accessibilityRole={Platform.OS === 'web' ? ('navigation' as any) : undefined} style={[styles.wrap, dense && styles.wrapDense]}>
      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        const key = item.key || `${idx}-${item.label}`;
        const showSep = idx !== items.length - 1;
        return (
          <View key={key} style={styles.itemRow}>
            {item.to ? (
              // Render as link whenever a `to` is provided (keep '指南' clickable even if it's last)
              <TouchableOpacity
                onPress={() => item.to && onNavigate && onNavigate(item.to)}
                activeOpacity={0.7}
                style={styles.linkTouch}
              >
                <Text style={[styles.linkText, dense && styles.textDense]} numberOfLines={1}>{item.label}</Text>
              </TouchableOpacity>
            ) : (
              <Text style={[styles.currentText, dense && styles.textDense]} numberOfLines={1}>{item.label}</Text>
            )}
            {showSep && (
              <Text style={[styles.sep, dense && styles.textDense]}>{` ${separator} `}</Text>
            )}
          </View>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: {
    flexDirection: 'row',
    alignItems: 'center',
    // prevent breadcrumb items from wrapping to next line; use ellipsis instead
    flexWrap: 'nowrap',
    overflow: 'hidden',
    paddingHorizontal: 16,
    paddingTop: 8,
  },
  wrapDense: {
    paddingHorizontal: 12,
    paddingTop: 6,
  },
  itemRow: {
    flexDirection: 'row',
    alignItems: 'center',
    maxWidth: '100%',
  },
  linkTouch: {
    paddingVertical: 2,
  },
  linkText: {
    color: '#2563EB',
    fontSize: 15,
    // allow truncation instead of wrapping
    flexShrink: 1,
    minWidth: 0,
  },
  currentText: {
    color: '#111827',
    fontSize: 15,
    fontWeight: '600',
    flexShrink: 1,
    minWidth: 0,
  },
  sep: {
    color: '#9CA3AF',
    fontSize: 15,
  },
  textDense: {
    fontSize: 14,
  },
});

export default Breadcrumbs;
